<ion-header class="ion-no-border">
  <ion-toolbar color="translucent">
    <ion-buttons slot="start">
      <ion-button (click)="close()">Cerrar</ion-button>
    </ion-buttons>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" fullscreen>
  <div id="qr-container" *ngIf="availability && qr">
    <qr-code [value]="qr" styleClass="aclass" size="350" errorCorrectionLevel="L"></qr-code>
    <p>Disponibilidad: {{ availability < 0 ? 0 : availability }}</p>
    <br />
  </div>
  <div *ngIf="availability===0">No hay disponibilidad</div>
</ion-content>
